import { Component } from 'react';
import { Switch } from 'react-router-dom';
import AccountSettings from './AccountSettings/AccountSettings';
import AdministratorPage from './Administrator/AdministratorPage';
import ManageCoTeachersPage from './Administrator/ManageCoTeachersPage';
import AuthenticatedRoute from './AuthenticatedRoute';
import Classroom from './Classroom/Classroom';
import StudentProfile from './ClassroomDashboard/StudentProfile';
import SubheaderRedirect from './core/SubheaderRedirect';
import GalleryDashboard from './Gallery/GalleryDashboard';
import MoreInformationSchool from './MoreInformationSchool';
import ReportsDashboard from './ReportsDashboard';
import { TakweenStudentSurveyConfirmation, TakweenStudentSurveyGrid, TakweenStudentSurveyPage } from './TakweenSurvey';
import ConnectParents from './Students/ConnectParents';
import MyPeekavilleUnits from './Students/MyPeekavilleUnits';
import Students from './Students/Students';
import TeacherCheckInTool from './TeacherCheckInTool/TeacherCheckInTool';
import LibraryRedirect from './TeacherLibrary/LibraryRedirect';
import VideoGallery from './VideoGallery';
import MyCoTeacherMembershipsPage from './MyCoTeacherMembershipsPage';

class ApplicationLayout extends Component {
  render() {
    // console.debug(
    //   `%cApplicationLayout render`,
    //   'background: blue; color: yellow'
    // );
    const newProps = { ...this.props };
    delete newProps.children;

    return (
      <div className='applicationLayout'>
        <SubheaderRedirect
          isAuthenticated={this.props.isAuthenticated}
          onAuthenticationChange={this.props.onAuthenticationChange}
          {...this.props}
        />
        <Switch>
          <AuthenticatedRoute path='/library'>
            <LibraryRedirect {...newProps} />
          </AuthenticatedRoute>
          <AuthenticatedRoute path='/students'>
            <Students {...newProps} />
          </AuthenticatedRoute>
          <AuthenticatedRoute path='/teacherLedCheckIn'>
            <TeacherCheckInTool {...newProps} />
          </AuthenticatedRoute>
          <AuthenticatedRoute path='/takween/survey/students'>
            <TakweenStudentSurveyGrid {...newProps} />
          </AuthenticatedRoute>
          <AuthenticatedRoute path='/takween/survey/confirmation'>
            <TakweenStudentSurveyConfirmation {...newProps} />
          </AuthenticatedRoute>
          <AuthenticatedRoute path='/takween/survey/:classroomId/:studentId'>
            <TakweenStudentSurveyPage {...newProps} />
          </AuthenticatedRoute>
          <AuthenticatedRoute path='/myPeekavilleUnits'>
            <MyPeekavilleUnits {...newProps} />
          </AuthenticatedRoute>
          <AuthenticatedRoute path='/connectParents'>
            <ConnectParents {...newProps} />
          </AuthenticatedRoute>
          <AuthenticatedRoute path='/classroom'>
            <Classroom {...newProps} />
          </AuthenticatedRoute>
          <AuthenticatedRoute path='/reports'>
            <ReportsDashboard {...newProps} />
          </AuthenticatedRoute>
          <AuthenticatedRoute path='/moreInformation/school'>
            <MoreInformationSchool {...newProps} />
          </AuthenticatedRoute>
          <AuthenticatedRoute path='/studentProfile/:studentID'>
            <StudentProfile {...newProps} />
          </AuthenticatedRoute>
          <AuthenticatedRoute path='/accountSettings'>
            <AccountSettings {...newProps} />
          </AuthenticatedRoute>
          <AuthenticatedRoute exact path='/administrator'>
            <AdministratorPage {...newProps} />
          </AuthenticatedRoute>
          <AuthenticatedRoute path='/administrator/co-teachers'>
            <ManageCoTeachersPage {...newProps} />
          </AuthenticatedRoute>
          <AuthenticatedRoute path='/gallery'>
            <GalleryDashboard {...newProps} />
          </AuthenticatedRoute>
          <AuthenticatedRoute path='/videos'>
            <VideoGallery {...newProps} />
          </AuthenticatedRoute>
          <AuthenticatedRoute path='/co-teacher-memberships'>
            <MyCoTeacherMembershipsPage />
          </AuthenticatedRoute>
        </Switch>
      </div>
    );
  }
}

export default ApplicationLayout;
